/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon-lab/core/page-live-doc';
import ObjectTileBase from '../object-tile-base';
export default function PageLiveDocObjectTile(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Page Live Doc' : _ref$label,
    size = _ref.size,
    testId = _ref.testId,
    isBold = _ref.isBold;
  return /*#__PURE__*/React.createElement(ObjectTileBase, {
    label: label,
    size: size,
    testId: testId,
    isBold: isBold,
    icon: IconComponent,
    color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-magenta, #CD519D)",
    backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
  });
}